module.exports = __webpack_public_path__ + "img/20.d86b3090.svg";